import React from 'react';
import Intercom from '@intercom/messenger-js-sdk';

import { UserContext } from './UserProvider';

import theme from '../theme';

const INTERCOM_APP_ID = 's01gy06y';

function IntercomChat() {
    const { user } = React.useContext(UserContext);

    // Users saved before the sign-in response included email and name won't
    // have them until they sign in again
    const loggedInEmail = user?.email ?? null;
    const loggedInName = user?.firstName
        ? `${user.firstName} ${user.lastName ?? ''}`.trim()
        : null;

    React.useEffect(() => {
        // Everyone stays an anonymous visitor, so the messenger only ever
        // shows this browser's own conversations, never an email's history.
        // The account is passed as plain info (unverified) rather than as
        // Intercom's identity fields, which would require signing. Null
        // clears it when nobody is signed in
        Intercom({
            app_id: INTERCOM_APP_ID,
            action_color: theme.palette.primary.main,
            background_color: theme.palette.primary.main,
            logged_in_name: loggedInName,
            logged_in_email: loggedInEmail,
        });
    }, [loggedInName, loggedInEmail]);

    return null;
}

export { IntercomChat };
